module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.df7b648.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.ttf
// module id = 318
// module chunks = 1